import { reactive, ref, watch } from 'vue';

interface UseCrudContentTaskDrawerState {
	isOpen: boolean;
	wasSuccessfullyCreated: boolean;
}

const DEFAULT_STATE: UseCrudContentTaskDrawerState = {
	isOpen: false,
	wasSuccessfullyCreated: false,
} as const;

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseCrudContentTaskDrawerState>(getDefaultState());

function resetState() {
	Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
	if (isOpen && !isRendered.value) isRendered.value = true;
});

export function useCrudContentTaskDrawer() {
	function open() {
		state.isOpen = true;
		state.wasSuccessfullyCreated = false;
	}

	function close() {
		state.isOpen = false;
	}

	function markAsCreated() {
		state.wasSuccessfullyCreated = true;
	}

	return {
		state,
		open,
		close,
		markAsCreated,
		resetState,
		isRendered,
	};
}

